import { render, staticRenderFns } from "./AdminPanelNews.vue?vue&type=template&id=ff8a44a2&scoped=true"
import script from "./AdminPanelNews.vue?vue&type=script&lang=js"
export * from "./AdminPanelNews.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelNews.vue?vue&type=style&index=0&id=ff8a44a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a44a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
